import axios from 'axios';
import CryptoJS from 'crypto-js';

const APP_KEY = 'rdYUFJnK$4VRia&1pa!1nzamUg0JL!Ci'; // 替换为你的APPKEY
// const GetGamesByGroupUrl = 'http://localhost:6619/api/client/getGamesByGroup';
// const GetGamesByGroupNameUrl = 'http://localhost:6619/api/client/getGamesByGroupName';
// const TransactionListByTelUrl = 'http://localhost:6619/api/resource/transactionListByTel';
const GetGamesByGroupUrl = 'https://back.51softdown.cn/api/client/getGamesByGroup';
const GetGamesByGroupNameUrl = 'https://back.51softdown.cn/api/client/getGamesByGroupName';
const TransactionListByTelUrl = 'https://back.51softdown.cn/api/resource/transactionListByTel';
const feedbackUrl = 'https://back.51softdown.cn/api/feedback/submit';

async function getGamesByGroup(id) {
  // 1. 准备参数
  const timestamp = Math.floor(Date.now() / 1000);
  const params = {
    id,
    timestamp
  };

  // 2. 生成签名
  const signParams = { ...params };
  const sortedKeys = Object.keys(signParams).sort();
  const paramString = sortedKeys
    .map(k => `${k}=${encodeURIComponent(signParams[k])}`)
    .join('&');
  
  const signContent = `${paramString}&key=${APP_KEY}`;
  const sign = CryptoJS.MD5(signContent).toString().toUpperCase();

  // 3. 构建FormData
  const formData = new FormData();
  formData.append('id', id);
  formData.append('timestamp', timestamp);

  // 4. 发送请求
  try {
    const response = await axios.post(
      GetGamesByGroupUrl,
      formData,
      {
        params: {
          timestamp,
          sign
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;
  }
}

async function getGamesByGroupName(groupName) {
  // 1. 准备参数
  const timestamp = Math.floor(Date.now() / 1000);
  const params = {
    groupName,
    timestamp
  };

  // 2. 生成签名
  const signParams = { ...params };
  const sortedKeys = Object.keys(signParams).sort();
  const paramString = sortedKeys
    .map(k => `${k}=${encodeURIComponent(signParams[k])}`)
    .join('&');
  
  const signContent = `${paramString}&key=${APP_KEY}`;
  const sign = CryptoJS.MD5(signContent).toString().toUpperCase();

  // 3. 构建URLSearchParams（用于application/x-www-form-urlencoded）
  const urlParams = new URLSearchParams();
  urlParams.append('groupName', groupName);
  urlParams.append('timestamp', timestamp);
  urlParams.append('sign', sign);

  // 4. 发送请求
  try {
    const response = await axios.post(
      GetGamesByGroupNameUrl,
      urlParams,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;
  }
}

async function getTransactionListByTel(tel) {
  // 构建FormData
  const formData = new FormData();
  formData.append('tel', tel);

  // 发送请求
  try {
    const response = await axios.post(
      TransactionListByTelUrl,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;
  }
}

export { getGamesByGroup, getGamesByGroupName, getTransactionListByTel, feedbackUrl };